import CardsPage from "./CardsPage";

export default CardsPage;
